module.exports = __webpack_public_path__ + "img/myPrize.dacafc60.png";